import React, { useEffect, useMemo, useState } from 'react';
import { Helmet } from 'react-helmet';
import {
  collection,
  addDoc,
  onSnapshot,
  orderBy,
  query,
  serverTimestamp,
  updateDoc,
  doc,
  getDoc,
  setDoc,
  runTransaction,
} from 'firebase/firestore';
import { db } from '../firebase';
import { PROMO_CODES_RAW } from './data/promoCodesRaw';


const STAFF_MEMBERS = ['Pierre', 'Maxence', 'Colin', 'Andy', 'Alexis', 'Brian', 'Emilien','Piet'];
const STATUS_OPTIONS = ['Lancé', 'Accepté pas lancé', 'A NE PAS LANCER'];
const PROMO_CODES_PER_TYPE = 4;

const BULK_EVENTS = [
  ['Eleven Padel Nivelles', 'Accepté pas lancé', '2026-08-28', '18h30 – 23h00'],
  ['Padel Eghezée', 'Accepté pas lancé', '2026-09-12', '13h00 – 17h30'],
  ['Limal Pulse', 'Accepté pas lancé', '2026-09-13', '14h00 – 18h30'],
  ['High 5 Padel LLN', 'Accepté pas lancé', '2026-09-18', '19h00 – 23h30'],
  ['Mokko Padel Project Floreffe', 'Accepté pas lancé', '2026-09-18', '18h30 – 23h00'],
  ['Padel Events Club Mont-Saint-Guibert', 'Accepté pas lancé', '2026-09-25', '19h00 – 23h30'],
  ['Padel Mettet', 'Accepté pas lancé', '2026-09-27', '14h00 – 18h30'],
  ['Tero Padel Namur', 'Accepté pas lancé', '2026-10-02', '18h30 – 23h00'],
  ['Tero Padel Charleroi', 'Accepté pas lancé', '2026-10-02', '18h30 – 23h00'],
  ['Eleven Padel Nivelles', 'Accepté pas lancé', '2026-10-03', '14h00 – 18h30'],
  ['Padel Eghezée', 'Accepté pas lancé', '2026-10-10', '13h00 – 17h30'],
  ['Bois du Loup Sombreffe', 'Accepté pas lancé', '2026-10-10', '14h00 – 18h30'],
  ['Limal Pulse', 'Accepté pas lancé', '2026-10-11', '14h00 – 18h30'],
  ['Ciney Padel Club', 'Accepté pas lancé', '2026-10-11', '14h00 – 18h30'],
  ['High 5 Padel LLN', 'Accepté pas lancé', '2026-10-16', '19h00 – 23h30'],
  ['Padel Mettet', 'Accepté pas lancé', '2026-10-18', '14h00 – 18h30'],
  ['Padel Events Club Mont-Saint-Guibert', 'Accepté pas lancé', '2026-10-23', '19h00 – 23h30'],
  ['Tero Padel Namur', 'Accepté pas lancé', '2026-10-30', '18h30 – 23h00'],
  ['Tero Padel Charleroi', 'Accepté pas lancé', '2026-10-30', '18h30 – 23h00'],
  ['Eleven Padel Nivelles', 'Accepté pas lancé', '2026-10-31', '14h00 – 18h30'],
  ['Padel Smash Gembloutois', 'Accepté pas lancé', '2026-11-01', '14h00 – 18h30'],
  ['Padel Eghezée', 'Accepté pas lancé', '2026-11-07', '13h00 – 17h30'],
  ['Bois du Loup Sombreffe', 'Accepté pas lancé', '2026-11-07', '14h00 – 18h30'],
  ['Limal Pulse', 'Accepté pas lancé', '2026-11-08', '14h00 – 18h30'],
  ['Ciney Padel Club', 'Accepté pas lancé', '2026-11-08', '14h00 – 18h30'],
  ['High 5 Padel LLN', 'Accepté pas lancé', '2026-11-13', '19h00 – 23h30'],
  ['Mokko Padel Project Floreffe', 'Accepté pas lancé', '2026-11-13', '18h30 – 23h00'],
  ['Padel Mettet', 'Accepté pas lancé', '2026-11-22', '14h00 – 18h30'],
  ['Tero Padel Charleroi', 'Accepté pas lancé', '2026-11-27', '18h30 – 23h00'],
  ['Tero Padel Namur', 'Accepté pas lancé', '2026-11-28', '18h30 – 23h00'],
  ['Eleven Padel Nivelles', 'Accepté pas lancé', '2026-11-28', '14h00 – 18h30'],
  ['Padel Smash Gembloutois', 'Accepté pas lancé', '2026-11-29', '14h00 – 18h30'],
  ['Padel Eghezée', 'Accepté pas lancé', '2026-12-05', '13h00 – 17h30'],
  ['Bois du Loup Sombreffe', 'Accepté pas lancé', '2026-12-05', '14h00 – 18h30'],
  ['Limal Pulse', 'Accepté pas lancé', '2026-12-06', '14h00 – 18h30'],
  ['High 5 Padel LLN', 'Accepté pas lancé', '2026-12-11', '19h00 – 23h30'],
  ['Mokko Padel Project Floreffe', 'Accepté pas lancé', '2026-12-11', '18h30 – 23h00'],
  ['Padel Events Club Mont-Saint-Guibert', 'Accepté pas lancé', '2026-12-18', '19h00 – 23h30'],
  ['Padel Mettet', 'Accepté pas lancé', '2026-12-20', '14h00 – 18h30'],
  ['Ciney Padel Club', 'Accepté pas lancé', '2026-12-20', '14h00 – 18h30'],
];

function formatDateFr(dateStr) {
  if (!dateStr) return 'À confirmer';
  const date = new Date(dateStr);
  if (Number.isNaN(date.getTime())) return dateStr;
  return date.toLocaleDateString('fr-BE');
}

function formatDateFull(dateStr) {
  if (!dateStr) return { short: 'À confirmer', day: '' };

  const date = new Date(dateStr);
  if (Number.isNaN(date.getTime())) return { short: dateStr, day: '' };

  return {
    short: date.toLocaleDateString('fr-BE', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    }),
    day: date.toLocaleDateString('fr-BE', {
      weekday: 'long',
    }),
  };
}

function sortEvents(a, b) {
  if (!a.date && !b.date) return 0;
  if (!a.date) return 1;
  if (!b.date) return -1;
  return new Date(a.date) - new Date(b.date);
}

function getMonthLabel(dateStr) {
  if (!dateStr) return 'Dates à confirmer';
  const date = new Date(dateStr);
  if (Number.isNaN(date.getTime())) return 'Dates à confirmer';
  return date.toLocaleDateString('fr-BE', { month: 'long', year: 'numeric' });
}

function statusBadgeClass(status) {
  if (status === 'Lancé') return 'bg-green-100 text-green-800';
  if (status === 'Accepté pas lancé') return 'bg-yellow-100 text-yellow-800';
  if (status === 'A NE PAS LANCER') return 'bg-red-100 text-red-800';
  return 'bg-gray-100 text-gray-700';
}

function availabilityBadgeClass(status) {
  if (status === 'dispo') return 'bg-green-100 text-green-800';
  if (status === 'pas_dispo') return 'bg-red-100 text-red-800';
  return 'bg-gray-100 text-gray-600';
}

function availabilityLabel(status) {
  if (status === 'dispo') return 'Dispo';
  if (status === 'pas_dispo') return 'Pas dispo';
  return '—';
}

function tournoiLabel(roundLabel) {
  return `Tournoi ${roundLabel || ''}`.trim();
}

function extractPromoPools(rawText = '') {
  const codes25 = Array.from(new Set(rawText.match(/MENDYX25-[A-Z0-9]+/g) || []));
  const codes15 = Array.from(new Set(rawText.match(/MENDYX15-[A-Z0-9]+/g) || []));
  return { codes25, codes15 };
}

const Planning = () => {
  const [events, setEvents] = useState([]);
  const [selectedStaff, setSelectedStaff] = useState('Pierre');
  const [selectedSummaryStaff, setSelectedSummaryStaff] = useState('Pierre');
  const [selectedMonth, setSelectedMonth] = useState('Tous');
  const [openMobileCards, setOpenMobileCards] = useState({});
  const [rowEdits, setRowEdits] = useState({});
  const [commentDrafts, setCommentDrafts] = useState({});
  const [newEvent, setNewEvent] = useState({
    roundLabel: '',
    status: 'Accepté pas lancé',
    assignedTo: 'A confirmer',
    date: '',
    note: '',
  });
  const [savingRows, setSavingRows] = useState({});
  const [assigningPromoRows, setAssigningPromoRows] = useState({});
  const [syncingPromoPool, setSyncingPromoPool] = useState(false);
  const [assigningAllPromos, setAssigningAllPromos] = useState(false);
  const [loading, setLoading] = useState(true);
  const [importingEvents, setImportingEvents] = useState(false);

  useEffect(() => {
    const q = query(collection(db, 'planningEvents'), orderBy('date', 'asc'));
    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        const list = snapshot.docs.map((item) => ({
          id: item.id,
          ...item.data(),
        }));
        setEvents(list);
        setLoading(false);
      },
      (error) => {
        console.error('Erreur chargement planning :', error);
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const nextEdits = {};
    const nextComments = {};

    events.forEach((event) => {
      nextEdits[event.id] = {
        status: event.status || 'Accepté pas lancé',
        assignedTo: event.assignedTo || 'A confirmer',
        date: event.date || '',
        note: event.note || '',
      };

      nextComments[event.id] = event.availabilities?.[selectedStaff]?.comment || '';
    });

    setRowEdits(nextEdits);
    setCommentDrafts(nextComments);
  }, [events, selectedStaff]);

  const groupedEvents = useMemo(() => {
    const sorted = [...events].sort(sortEvents);
    const groups = {};

    sorted.forEach((event) => {
      const label = getMonthLabel(event.date);
      if (label === 'Dates à confirmer') return;
      if (!groups[label]) groups[label] = [];
      groups[label].push(event);
    });

    return groups;
  }, [events]);

  const monthButtons = useMemo(() => ['Tous', ...Object.keys(groupedEvents)], [groupedEvents]);

  const displayedGroups = useMemo(() => {
    if (selectedMonth === 'Tous') return groupedEvents;
    return selectedMonth in groupedEvents ? { [selectedMonth]: groupedEvents[selectedMonth] } : {};
  }, [groupedEvents, selectedMonth]);

  const summaryByStaff = useMemo(() => {
    const result = {};

    STAFF_MEMBERS.forEach((staff) => {
      result[staff] = [];
    });

    events.forEach((event) => {
      if (event.assignedTo && STAFF_MEMBERS.includes(event.assignedTo)) {
        result[event.assignedTo].push(event);
      }
    });

    return result;
  }, [events]);

  const updateRowEdit = (eventId, field, value) => {
    setRowEdits((prev) => ({
      ...prev,
      [eventId]: {
        ...prev[eventId],
        [field]: value,
      },
    }));
  };

  const toggleMobileCard = (eventId) => {
    setOpenMobileCards((prev) => ({
      ...prev,
      [eventId]: !prev[eventId],
    }));
  };

  const handleSaveRow = async (eventId) => {
    const edit = rowEdits[eventId];
    if (!edit) return;

    setSavingRows((prev) => ({ ...prev, [eventId]: true }));

    try {
      await updateDoc(doc(db, 'planningEvents', eventId), {
        status: edit.status,
        assignedTo: edit.assignedTo,
        date: edit.date,
        note: edit.note,
        updatedAt: serverTimestamp(),
      });
    } catch (error) {
      console.error('Erreur sauvegarde ligne :', error);
      alert('Erreur pendant l’enregistrement.');
    } finally {
      setSavingRows((prev) => ({ ...prev, [eventId]: false }));
    }
  };

  const handleSetAvailability = async (eventId, availabilityStatus) => {
    try {
      const event = events.find((item) => item.id === eventId);
      if (!event) return;

      const currentComment =
        commentDrafts[eventId] ?? event.availabilities?.[selectedStaff]?.comment ?? '';

      await updateDoc(doc(db, 'planningEvents', eventId), {
        [`availabilities.${selectedStaff}`]: {
          status: availabilityStatus,
          comment: currentComment,
          updatedAt: new Date().toISOString(),
        },
        updatedAt: serverTimestamp(),
      });
    } catch (error) {
      console.error('Erreur dispo :', error);
      alert('Erreur pendant la sauvegarde de la dispo.');
    }
  };

  const handleSaveComment = async (eventId) => {
    try {
      const event = events.find((item) => item.id === eventId);
      if (!event) return;

      const currentStatus = event.availabilities?.[selectedStaff]?.status || '';
      const currentComment = commentDrafts[eventId] || '';

      await updateDoc(doc(db, 'planningEvents', eventId), {
        [`availabilities.${selectedStaff}`]: {
          status: currentStatus,
          comment: currentComment,
          updatedAt: new Date().toISOString(),
        },
        updatedAt: serverTimestamp(),
      });
    } catch (error) {
      console.error('Erreur commentaire :', error);
      alert('Erreur pendant la sauvegarde du commentaire.');
    }
  };

  const handleSyncPromoPool = async () => {
    setSyncingPromoPool(true);

    try {
      const { codes25, codes15 } = extractPromoPools(PROMO_CODES_RAW);

      if (codes25.length === 0 && codes15.length === 0) {
        alert('Aucun code promo détecté dans promoCodesRaw.js');
        return;
      }

      const promoPoolRef = doc(db, 'appConfig', 'promoCodesPool');
      const promoPoolSnap = await getDoc(promoPoolRef);

      const currentData = promoPoolSnap.exists() ? promoPoolSnap.data() : {};

      const currentAvailable25 = Array.isArray(currentData.available25) ? currentData.available25 : [];
      const currentUsed25 = Array.isArray(currentData.used25) ? currentData.used25 : [];
      const currentAvailable15 = Array.isArray(currentData.available15) ? currentData.available15 : [];
      const currentUsed15 = Array.isArray(currentData.used15) ? currentData.used15 : [];

      const known25 = new Set([...currentAvailable25, ...currentUsed25]);
      const known15 = new Set([...currentAvailable15, ...currentUsed15]);

      const newAvailable25 = [...currentAvailable25];
      const newAvailable15 = [...currentAvailable15];

      let added25 = 0;
      let added15 = 0;

      codes25.forEach((code) => {
        if (!known25.has(code)) {
          newAvailable25.push(code);
          known25.add(code);
          added25 += 1;
        }
      });

      codes15.forEach((code) => {
        if (!known15.has(code)) {
          newAvailable15.push(code);
          known15.add(code);
          added15 += 1;
        }
      });

      await setDoc(
        promoPoolRef,
        {
          available25: newAvailable25,
          used25: currentUsed25,
          available15: newAvailable15,
          used15: currentUsed15,
          updatedAt: serverTimestamp(),
          ...(promoPoolSnap.exists() ? {} : { createdAt: serverTimestamp() }),
        },
        { merge: true }
      );

      alert(
        `Réserve promo synchronisée.\nAjoutés : ${added25} codes 25% et ${added15} codes 15%.`
      );
    } catch (error) {
      console.error('Erreur synchronisation réserve promo :', error);
      alert('Erreur pendant la synchronisation des codes promo.');
    } finally {
      setSyncingPromoPool(false);
    }
  };

  const assignPromoCodesToEvent = async (eventId, options = {}) => {
    const { silent = false } = options;

    setAssigningPromoRows((prev) => ({ ...prev, [eventId]: true }));

    try {
      const eventRef = doc(db, 'planningEvents', eventId);
      const promoPoolRef = doc(db, 'appConfig', 'promoCodesPool');

      let result = {
        added25: 0,
        added15: 0,
        skipped: false,
      };

      await runTransaction(db, async (transaction) => {
        const eventSnap = await transaction.get(eventRef);
        const promoPoolSnap = await transaction.get(promoPoolRef);

        if (!eventSnap.exists()) {
          throw new Error('Tournoi introuvable.');
        }

        if (!promoPoolSnap.exists()) {
          throw new Error('Synchronise d’abord la réserve promo.');
        }

        const eventData = eventSnap.data();
        const poolData = promoPoolSnap.data();

        const currentCodes25 = Array.isArray(eventData?.promoCodes?.codes25)
          ? eventData.promoCodes.codes25
          : [];
        const currentCodes15 = Array.isArray(eventData?.promoCodes?.codes15)
          ? eventData.promoCodes.codes15
          : [];

        const need25 = Math.max(0, PROMO_CODES_PER_TYPE - currentCodes25.length);
        const need15 = Math.max(0, PROMO_CODES_PER_TYPE - currentCodes15.length);

        if (need25 === 0 && need15 === 0) {
          result = { added25: 0, added15: 0, skipped: true };
          return;
        }

        const available25 = Array.isArray(poolData.available25) ? poolData.available25 : [];
        const used25 = Array.isArray(poolData.used25) ? poolData.used25 : [];
        const available15 = Array.isArray(poolData.available15) ? poolData.available15 : [];
        const used15 = Array.isArray(poolData.used15) ? poolData.used15 : [];

        if (available25.length < need25) {
          throw new Error('Pas assez de codes promo 25% disponibles.');
        }

        if (available15.length < need15) {
          throw new Error('Pas assez de codes promo 15% disponibles.');
        }

        const taken25 = available25.slice(0, need25);
        const taken15 = available15.slice(0, need15);

        result = {
          added25: taken25.length,
          added15: taken15.length,
          skipped: false,
        };

        transaction.update(eventRef, {
          promoCodes: {
            codes25: [...currentCodes25, ...taken25],
            codes15: [...currentCodes15, ...taken15],
            assignedAt: new Date().toISOString(),
          },
          updatedAt: serverTimestamp(),
        });

        transaction.update(promoPoolRef, {
          available25: available25.slice(taken25.length),
          used25: [...used25, ...taken25],
          available15: available15.slice(taken15.length),
          used15: [...used15, ...taken15],
          updatedAt: serverTimestamp(),
        });
      });

      if (!silent) {
        if (result.skipped) {
          alert('Ce tournoi a déjà ses 4 codes 25% et 4 codes 15%.');
        } else {
          alert(
            `Codes attribués : ${result.added25} code(s) 25% et ${result.added15} code(s) 15%.`
          );
        }
      }

      return result;
    } catch (error) {
      console.error('Erreur attribution codes promo :', error);
      if (!silent) {
        alert(error.message || 'Erreur pendant l’attribution des codes promo.');
      }
      throw error;
    } finally {
      setAssigningPromoRows((prev) => ({ ...prev, [eventId]: false }));
    }
  };

  const handleAssignMissingCodesToAll = async () => {
    setAssigningAllPromos(true);

    try {
      let updatedCount = 0;

      for (const event of events) {
        const count25 = event.promoCodes?.codes25?.length || 0;
        const count15 = event.promoCodes?.codes15?.length || 0;

        if (count25 < PROMO_CODES_PER_TYPE || count15 < PROMO_CODES_PER_TYPE) {
          const result = await assignPromoCodesToEvent(event.id, { silent: true });
          if (result && !result.skipped) {
            updatedCount += 1;
          }
        }
      }

      alert(`Attribution terminée. ${updatedCount} tournoi(s) mis à jour.`);
    } catch (error) {
      console.error('Erreur attribution globale :', error);
      alert(error.message || 'Erreur pendant l’attribution globale.');
    } finally {
      setAssigningAllPromos(false);
    }
  };

  const handleAddEvent = async (e) => {
    e.preventDefault();

    try {
      const availabilities = {};
      STAFF_MEMBERS.forEach((staff) => {
        availabilities[staff] = { status: '', comment: '' };
      });

      const createdRef = await addDoc(collection(db, 'planningEvents'), {
        roundLabel: newEvent.roundLabel,
        club: '',
        status: newEvent.status,
        assignedTo: newEvent.assignedTo,
        date: newEvent.date,
        note: newEvent.note.trim(),
        availabilities,
        promoCodes: {
          codes25: [],
          codes15: [],
        },
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp(),
      });

      try {
        await assignPromoCodesToEvent(createdRef.id, { silent: true });
      } catch (promoError) {
        console.error('Tournoi créé mais codes promo non attribués :', promoError);
        alert(
          'Tournoi ajouté, mais les codes promo n’ont pas été attribués. Synchronise la réserve puis clique sur le bouton d’attribution.'
        );
      }

      setNewEvent({
        roundLabel: '',
        status: 'Accepté pas lancé',
        assignedTo: 'A confirmer',
        date: '',
        note: '',
      });
    } catch (error) {
      console.error('Erreur ajout tournoi :', error);
      alert('Erreur pendant l’ajout.');
    }
  };

  const handleBulkImportEvents = async () => {
    if (importingEvents) return;
  
    setImportingEvents(true);
  
    try {
      const existingKeys = new Set(
        events.map(
          (event) =>
            `${event.club || event.roundLabel}|${event.date}|${event.note || ''}`
        )
      );
  
      let importedCount = 0;
      let skippedCount = 0;
  
      for (const [club, status, date, note] of BULK_EVENTS) {
        const eventKey = `${club}|${date}|${note}`;
  
        if (existingKeys.has(eventKey)) {
          skippedCount += 1;
          continue;
        }
  
        const availabilities = {};
  
        STAFF_MEMBERS.forEach((staff) => {
          availabilities[staff] = {
            status: '',
            comment: '',
          };
        });
  
        await addDoc(collection(db, 'planningEvents'), {
          roundLabel: club,
          club,
          status,
          assignedTo: 'A confirmer',
          date,
          note,
          availabilities,
          promoCodes: {
            codes25: [],
            codes15: [],
          },
          createdAt: serverTimestamp(),
          updatedAt: serverTimestamp(),
        });
  
        existingKeys.add(eventKey);
        importedCount += 1;
      }
  
      alert(
        `Import terminé : ${importedCount} tournoi(s) ajouté(s)${
          skippedCount ? `, ${skippedCount} déjà présent(s)` : ''
        }.`
      );
    } catch (error) {
      console.error('Erreur pendant l’import :', error);
      alert('Erreur pendant l’import des tournois.');
    } finally {
      setImportingEvents(false);
    }
  };

  const renderDisposList = (event) => (
    <div className="space-y-1.5">
      {STAFF_MEMBERS.map((name) => {
        const dispo = event.availabilities?.[name];
        if (!dispo || (!dispo.status && !dispo.comment)) return null;

        return (
          <div key={name} className="border rounded-lg px-2.5 py-2 bg-gray-50">
            <div className="flex items-center justify-between gap-2">
              <span className="font-medium text-sm">{name}</span>
              <span
                className={`text-[11px] px-2 py-1 rounded-full ${availabilityBadgeClass(
                  dispo.status
                )}`}
              >
                {availabilityLabel(dispo.status)}
              </span>
            </div>
            {dispo.comment && <div className="text-xs text-gray-500 mt-1">{dispo.comment}</div>}
          </div>
        );
      })}
    </div>
  );

  const renderDispoEditor = (event, myStatus) => (
    <div className="space-y-2.5">
      <div className="text-sm font-medium text-[#4c2f8e]">Dispo de {selectedStaff}</div>

      <div className="flex flex-wrap gap-2">
        <button
          type="button"
          onClick={() => handleSetAvailability(event.id, 'dispo')}
          className={`px-3 py-2 rounded-full text-sm text-white ${
            myStatus === 'dispo' ? 'bg-green-800' : 'bg-green-600'
          }`}
        >
          Dispo
        </button>

        <button
          type="button"
          onClick={() => handleSetAvailability(event.id, 'pas_dispo')}
          className={`px-3 py-2 rounded-full text-sm text-white ${
            myStatus === 'pas_dispo' ? 'bg-red-800' : 'bg-red-600'
          }`}
        >
          Pas dispo
        </button>
      </div>

      <textarea
        rows="2"
        placeholder={`Commentaire pour ${selectedStaff}`}
        value={commentDrafts[event.id] || ''}
        onChange={(e) =>
          setCommentDrafts((prev) => ({
            ...prev,
            [event.id]: e.target.value,
          }))
        }
        className="w-full border rounded-xl px-3 py-2 text-sm"
      />

      <button
        type="button"
        onClick={() => handleSaveComment(event.id)}
        className="px-3 py-2 rounded-xl bg-gray-700 text-white text-sm hover:bg-gray-800 transition"
      >
        Enregistrer commentaire
      </button>
    </div>
  );

  const renderPromoCodes = (event) => {
    const codes25 = event.promoCodes?.codes25 || [];
    const codes15 = event.promoCodes?.codes15 || [];

    return (
      <div className="space-y-3">
        <div>
          <div className="flex items-center justify-between mb-1">
            <div className="text-xs font-semibold text-[#4c2f8e]">Codes 25%</div>
            <div className="text-[11px] text-gray-500">
              {codes25.length}/{PROMO_CODES_PER_TYPE}
            </div>
          </div>

          <div className="flex flex-wrap gap-2">
            {codes25.length === 0 ? (
              <span className="text-xs text-gray-400">Aucun code</span>
            ) : (
              codes25.map((code) => (
                <span
                  key={code}
                  className="px-2 py-1 rounded-lg bg-green-50 text-green-700 text-xs border border-green-200"
                >
                  {code}
                </span>
              ))
            )}
          </div>
        </div>

        <div>
          <div className="flex items-center justify-between mb-1">
            <div className="text-xs font-semibold text-[#4c2f8e]">Codes 15%</div>
            <div className="text-[11px] text-gray-500">
              {codes15.length}/{PROMO_CODES_PER_TYPE}
            </div>
          </div>

          <div className="flex flex-wrap gap-2">
            {codes15.length === 0 ? (
              <span className="text-xs text-gray-400">Aucun code</span>
            ) : (
              codes15.map((code) => (
                <span
                  key={code}
                  className="px-2 py-1 rounded-lg bg-blue-50 text-blue-700 text-xs border border-blue-200"
                >
                  {code}
                </span>
              ))
            )}
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <Helmet>
        <title>Planning | Padel Mendyx</title>
        <meta
          name="description"
          content="Planning interne des tournois, dispos, assignations et codes promo."
        />
      </Helmet>

      <section className="w-full px-3 md:px-5 xl:px-8 my-8">
        <div className="mb-6">
          <h1 className="text-3xl md:text-5xl font-bold text-[#4c2f8e] text-center">Planning</h1>
          <p className="text-center text-gray-600 mt-2 text-sm md:text-base">
            Gestion des dates, des dispos, des assignations et des codes promo.
          </p>
        </div>

        <div className="bg-white rounded-3xl shadow-lg border border-gray-200 p-4 md:p-5 mb-6">
          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
            <div className="flex flex-col md:flex-row md:items-center gap-3">
              <label className="font-semibold text-[#4c2f8e] text-sm md:text-base">Prénom :</label>
              <select
                value={selectedStaff}
                onChange={(e) => setSelectedStaff(e.target.value)}
                className="border rounded-xl px-4 py-2.5 text-sm md:text-base min-w-[220px]"
              >
                {STAFF_MEMBERS.map((name) => (
                  <option key={name} value={name}>
                    {name}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <div className="text-sm font-semibold text-[#4c2f8e] mb-2">Mois</div>
              <div className="flex flex-wrap gap-2">
                {monthButtons.map((month) => (
                  <button
                    key={month}
                    type="button"
                    onClick={() => setSelectedMonth(month)}
                    className={`px-3 py-2 rounded-full border text-sm font-medium transition ${
                      selectedMonth === month
                        ? 'bg-[#4c2f8e] text-white border-[#4c2f8e]'
                        : 'bg-white text-[#4c2f8e] border-[#4c2f8e] hover:bg-[#4c2f8e] hover:text-white'
                    }`}
                  >
                    {month}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-3xl shadow-lg border border-gray-200 p-4 md:p-5 mb-6">
          <div className="flex flex-col gap-4">
            <div>
              <h2 className="text-xl md:text-2xl font-semibold text-[#4c2f8e]">Résumé</h2>
              <p className="text-sm text-gray-600 mt-1">
                Clique sur un prénom pour voir ses tournois assignés.
              </p>
            </div>

            <div className="flex flex-wrap gap-2">
              {STAFF_MEMBERS.map((name) => (
                <button
                  key={name}
                  type="button"
                  onClick={() => setSelectedSummaryStaff(name)}
                  className={`px-3 py-2 rounded-full border text-sm font-medium transition ${
                    selectedSummaryStaff === name
                      ? 'bg-[#4c2f8e] text-white border-[#4c2f8e]'
                      : 'bg-white text-[#4c2f8e] border-[#4c2f8e] hover:bg-[#4c2f8e] hover:text-white'
                  }`}
                >
                  {name}
                </button>
              ))}
            </div>

            <div className="rounded-2xl border border-gray-200 p-4 bg-[#faf8ff]">
              <div className="flex items-center justify-between mb-3">
                <h3 className="text-lg font-semibold text-[#4c2f8e]">
                  Assigné à {selectedSummaryStaff}
                </h3>
                <span className="px-3 py-1 rounded-full bg-[#ede7fb] text-[#4c2f8e] text-sm font-medium">
                  {summaryByStaff[selectedSummaryStaff]?.length || 0}
                </span>
              </div>

              <div className="grid grid-cols-1 xl:grid-cols-2 gap-3">
                {(summaryByStaff[selectedSummaryStaff] || []).length === 0 ? (
                  <p className="text-sm text-gray-500">Aucun tournoi assigné.</p>
                ) : (
                  summaryByStaff[selectedSummaryStaff]
                    .slice()
                    .sort(sortEvents)
                    .map((event) => (
                      <div key={`assigned-${event.id}`} className="bg-white border rounded-xl p-3">
                        <div className="font-semibold text-[#4c2f8e]">{tournoiLabel(event.roundLabel)}</div>
                        <div className="text-sm text-gray-600 mt-1">{formatDateFr(event.date)}</div>
                        <div className="mt-2">
                          <span
                            className={`inline-block px-2 py-1 rounded-full text-xs font-semibold ${statusBadgeClass(
                              event.status
                            )}`}
                          >
                            {event.status}
                          </span>
                        </div>
                        {event.note && <div className="text-xs text-gray-500 mt-2">{event.note}</div>}
                      </div>
                    ))
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-3xl shadow-lg border border-gray-200 p-4 md:p-5 mb-8">
          <h2 className="text-xl md:text-2xl font-semibold text-[#4c2f8e] mb-4">
            Ajouter une date / un tournoi
          </h2>

          <form onSubmit={handleAddEvent} className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-5 gap-3">
            <input
              type="text"
              placeholder="Tournoi (1, 2, 3, 4...)"
              value={newEvent.roundLabel}
              onChange={(e) => setNewEvent((prev) => ({ ...prev, roundLabel: e.target.value }))}
              className="border rounded-xl px-4 py-2.5 text-sm md:text-base"
            />
            <input
              type="date"
              value={newEvent.date}
              onChange={(e) => setNewEvent((prev) => ({ ...prev, date: e.target.value }))}
              className="border rounded-xl px-4 py-2.5 text-sm md:text-base"
            />
            <select
              value={newEvent.status}
              onChange={(e) => setNewEvent((prev) => ({ ...prev, status: e.target.value }))}
              className="border rounded-xl px-4 py-2.5 text-sm md:text-base"
            >
              {STATUS_OPTIONS.map((status) => (
                <option key={status} value={status}>
                  {status}
                </option>
              ))}
            </select>
            <select
              value={newEvent.assignedTo}
              onChange={(e) => setNewEvent((prev) => ({ ...prev, assignedTo: e.target.value }))}
              className="border rounded-xl px-4 py-2.5 text-sm md:text-base"
            >
              <option value="A confirmer">A confirmer</option>
              {STAFF_MEMBERS.map((name) => (
                <option key={name} value={name}>
                  {name}
                </option>
              ))}
            </select>
            <input
              type="text"
              placeholder="Note"
              value={newEvent.note}
              onChange={(e) => setNewEvent((prev) => ({ ...prev, note: e.target.value }))}
              className="border rounded-xl px-4 py-2.5 text-sm md:text-base"
            />

            <button
              type="submit"
              className="md:col-span-2 xl:col-span-5 px-4 py-3 rounded-xl bg-[#4c2f8e] text-white hover:bg-[#3d2572] transition text-sm md:text-base font-medium"
            >
              Ajouter au planning
            </button>
          </form>

          <div className="flex flex-wrap gap-3 mt-4">
            <button
              type="button"
              onClick={handleSyncPromoPool}
              disabled={syncingPromoPool}
              className="px-4 py-3 rounded-xl bg-gray-800 text-white hover:bg-gray-900 transition disabled:opacity-50 text-sm md:text-base font-medium"
            >
              {syncingPromoPool ? 'Synchronisation...' : 'Synchroniser la réserve promo'}

      
            </button>
            <button
  type="button"
  onClick={handleBulkImportEvents}
  disabled={importingEvents}
  className="px-4 py-3 rounded-xl bg-blue-600 text-white hover:bg-blue-700 transition disabled:opacity-50 text-sm md:text-base font-medium"
>
  {importingEvents
    ? 'Import en cours...'
    : 'Importer les 40 tournois (août à décembre)'}
</button>

            <button
              type="button"
              onClick={handleAssignMissingCodesToAll}
              disabled={assigningAllPromos}
              className="px-4 py-3 rounded-xl bg-emerald-600 text-white hover:bg-emerald-700 transition disabled:opacity-50 text-sm md:text-base font-medium"
            >
              {assigningAllPromos
                ? 'Attribution...'
                : 'Attribuer les codes manquants à tous les tournois'}
            </button>
          </div>

          <p className="text-xs text-gray-500 mt-3">
            Chaque tournoi reçoit automatiquement 4 codes 25% et 4 codes 15%.
          </p>
        </div>

        {loading ? (
          <div className="text-center py-16 text-gray-500">Chargement du planning...</div>
        ) : Object.keys(displayedGroups).length === 0 ? (
          <div className="text-center py-16 text-gray-500">Aucun élément dans ce mois.</div>
        ) : (
          Object.entries(displayedGroups).map(([monthLabel, monthEvents]) => (
            <div key={monthLabel} className="mb-8">
              <div className="flex items-center gap-3 mb-3">
                <div className="h-7 w-2 rounded-full bg-[#4c2f8e]"></div>
                <h2 className="text-xl md:text-2xl font-semibold text-[#4c2f8e] capitalize">
                  {monthLabel}
                </h2>
                <span className="px-3 py-1 rounded-full bg-[#f3effc] text-[#4c2f8e] text-xs md:text-sm font-medium">
                  {monthEvents.length} tournoi{monthEvents.length > 1 ? 's' : ''}
                </span>
              </div>

              <div className="lg:hidden space-y-3">
                {monthEvents.map((event) => {
                  const edit = rowEdits[event.id] || {
                    status: event.status || 'Accepté pas lancé',
                    assignedTo: event.assignedTo || 'A confirmer',
                    date: event.date || '',
                    note: event.note || '',
                  };

                  const myStatus = event.availabilities?.[selectedStaff]?.status || '';
                  const dateDisplay = formatDateFull(edit.date);
                  const isOpen = !!openMobileCards[event.id];

                  return (
                    <div
                      key={event.id}
                      className="bg-white rounded-2xl shadow border border-gray-200 overflow-hidden"
                    >
                      <button
                        type="button"
                        onClick={() => toggleMobileCard(event.id)}
                        className="w-full text-left p-4"
                      >
                        <div className="flex items-start justify-between gap-3">
                          <div>
                            <div className="text-base font-bold text-[#4c2f8e]">
                              {tournoiLabel(event.roundLabel)}
                            </div>
                            <div className="mt-2 inline-block px-3 py-2 rounded-xl bg-[#f3effc] border border-[#d7c8f3]">
                              <div className="text-base font-bold text-[#4c2f8e]">{dateDisplay.short}</div>
                              {dateDisplay.day && (
                                <div className="text-xs text-[#4c2f8e] capitalize mt-1">
                                  {dateDisplay.day}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="flex flex-col items-end gap-2">
                            <span
                              className={`px-2 py-1 rounded-full text-[11px] font-semibold ${statusBadgeClass(
                                edit.status
                              )}`}
                            >
                              {edit.status}
                            </span>
                            <span className="text-[#4c2f8e] text-sm">{isOpen ? '−' : '+'}</span>
                          </div>
                        </div>
                      </button>

                      {isOpen && (
                        <div className="px-4 pb-4 border-t bg-gray-50">
                          <div className="space-y-3 pt-4">
                            <div>
                              <label className="block text-sm font-medium text-[#4c2f8e] mb-1">
                                Statut
                              </label>
                              <select
                                value={edit.status}
                                onChange={(e) => updateRowEdit(event.id, 'status', e.target.value)}
                                className="border rounded-xl px-3 py-2.5 w-full bg-white text-sm"
                              >
                                {STATUS_OPTIONS.map((status) => (
                                  <option key={status} value={status}>
                                    {status}
                                  </option>
                                ))}
                              </select>
                            </div>

                            <div>
                              <label className="block text-sm font-medium text-[#4c2f8e] mb-1">
                                Assigné à
                              </label>
                              <select
                                value={edit.assignedTo}
                                onChange={(e) => updateRowEdit(event.id, 'assignedTo', e.target.value)}
                                className="border rounded-xl px-3 py-2.5 w-full bg-white text-sm"
                              >
                                <option value="A confirmer">A confirmer</option>
                                {STAFF_MEMBERS.map((name) => (
                                  <option key={name} value={name}>
                                    {name}
                                  </option>
                                ))}
                              </select>
                            </div>

                            <div>
                              <label className="block text-sm font-medium text-[#4c2f8e] mb-1">
                                Date
                              </label>
                              <input
                                type="date"
                                value={edit.date}
                                onChange={(e) => updateRowEdit(event.id, 'date', e.target.value)}
                                className="border rounded-xl px-3 py-2.5 w-full bg-white text-sm"
                              />
                              <div className="text-xs text-gray-500 mt-2">{formatDateFr(edit.date)}</div>
                            </div>

                            <div>
                              <label className="block text-sm font-medium text-[#4c2f8e] mb-1">
                                Note
                              </label>
                              <input
                                type="text"
                                value={edit.note}
                                onChange={(e) => updateRowEdit(event.id, 'note', e.target.value)}
                                className="border rounded-xl px-3 py-2.5 w-full bg-white text-sm"
                              />
                            </div>

                            <div>
                              <div className="text-sm font-medium text-[#4c2f8e] mb-2">Dispos</div>
                              {renderDisposList(event)}
                            </div>

                            <div className="pt-2 border-t">{renderDispoEditor(event, myStatus)}</div>

                            <div className="pt-2 border-t">
                              <div className="text-sm font-medium text-[#4c2f8e] mb-2">Codes promo</div>
                              {renderPromoCodes(event)}
                            </div>

                            <button
                              type="button"
                              onClick={() => assignPromoCodesToEvent(event.id)}
                              disabled={assigningPromoRows[event.id]}
                              className="w-full px-4 py-3 rounded-xl bg-emerald-600 text-white hover:bg-emerald-700 transition disabled:opacity-50 text-sm"
                            >
                              {assigningPromoRows[event.id]
                                ? 'Attribution...'
                                : 'Attribuer les codes manquants'}
                            </button>

                            <button
                              type="button"
                              onClick={() => handleSaveRow(event.id)}
                              disabled={savingRows[event.id]}
                              className="w-full px-4 py-3 rounded-xl bg-[#4c2f8e] text-white hover:bg-[#3d2572] transition disabled:opacity-50 text-sm"
                            >
                              {savingRows[event.id] ? 'Enregistrement...' : 'Enregistrer'}
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>

              <div className="hidden lg:block overflow-x-auto bg-white rounded-3xl shadow-lg border border-gray-200">
                <table className="min-w-[1500px] w-full text-sm">
                  <thead className="bg-[#4c2f8e] text-white">
                    <tr>
                      <th className="px-4 py-3 text-left">Tournoi</th>
                      <th className="px-4 py-3 text-left">Statut</th>
                      <th className="px-4 py-3 text-left">Assigné à</th>
                      <th className="px-4 py-3 text-left">Date</th>
                      <th className="px-4 py-3 text-left">Dispos</th>
                      <th className="px-4 py-3 text-left">Ma dispo</th>
                      <th className="px-4 py-3 text-left">Codes promo</th>
                      <th className="px-4 py-3 text-left">Action</th>
                    </tr>
                  </thead>

                  <tbody>
                    {monthEvents.map((event) => {
                      const edit = rowEdits[event.id] || {
                        status: event.status || 'Accepté pas lancé',
                        assignedTo: event.assignedTo || 'A confirmer',
                        date: event.date || '',
                        note: event.note || '',
                      };

                      const myStatus = event.availabilities?.[selectedStaff]?.status || '';
                      const dateDisplay = formatDateFull(edit.date);

                      return (
                        <tr key={event.id} className="border-t align-top">
                          <td className="px-4 py-4 min-w-[170px]">
                            <div className="font-semibold text-[#4c2f8e] text-base">
                              {tournoiLabel(event.roundLabel)}
                            </div>
                            {edit.note && <div className="text-xs text-gray-500 mt-1">{edit.note}</div>}
                          </td>

                          <td className="px-4 py-4 min-w-[180px]">
                            <select
                              value={edit.status}
                              onChange={(e) => updateRowEdit(event.id, 'status', e.target.value)}
                              className="border rounded-xl px-3 py-2.5 w-full text-sm"
                            >
                              {STATUS_OPTIONS.map((status) => (
                                <option key={status} value={status}>
                                  {status}
                                </option>
                              ))}
                            </select>

                            <div className="mt-2">
                              <span
                                className={`inline-block px-2 py-1 rounded-full text-xs font-semibold ${statusBadgeClass(
                                  edit.status
                                )}`}
                              >
                                {edit.status}
                              </span>
                            </div>
                          </td>

                          <td className="px-4 py-4 min-w-[180px]">
                            <select
                              value={edit.assignedTo}
                              onChange={(e) => updateRowEdit(event.id, 'assignedTo', e.target.value)}
                              className="border rounded-xl px-3 py-2.5 w-full text-sm"
                            >
                              <option value="A confirmer">A confirmer</option>
                              {STAFF_MEMBERS.map((name) => (
                                <option key={name} value={name}>
                                  {name}
                                </option>
                              ))}
                            </select>
                          </td>

                          <td className="px-4 py-4 min-w-[220px]">
                            <div className="mb-2 p-3 rounded-2xl bg-[#f3effc] border border-[#d7c8f3]">
                              <div className="text-lg font-bold text-[#4c2f8e]">{dateDisplay.short}</div>
                              {dateDisplay.day && (
                                <div className="text-xs text-[#4c2f8e] capitalize font-medium mt-1">
                                  {dateDisplay.day}
                                </div>
                              )}
                            </div>

                            <input
                              type="date"
                              value={edit.date}
                              onChange={(e) => updateRowEdit(event.id, 'date', e.target.value)}
                              className="border rounded-xl px-3 py-2.5 w-full text-sm"
                            />
                          </td>

                          <td className="px-4 py-4 min-w-[220px]">{renderDisposList(event)}</td>

                          <td className="px-4 py-4 min-w-[240px]">{renderDispoEditor(event, myStatus)}</td>

                          <td className="px-4 py-4 min-w-[320px]">
                            {renderPromoCodes(event)}

                            <button
                              type="button"
                              onClick={() => assignPromoCodesToEvent(event.id)}
                              disabled={assigningPromoRows[event.id]}
                              className="mt-3 px-4 py-2 rounded-xl bg-emerald-600 text-white hover:bg-emerald-700 transition disabled:opacity-50 text-sm font-medium"
                            >
                              {assigningPromoRows[event.id]
                                ? 'Attribution...'
                                : 'Attribuer les codes manquants'}
                            </button>
                          </td>

                          <td className="px-4 py-4 min-w-[120px]">
                            <button
                              type="button"
                              onClick={() => handleSaveRow(event.id)}
                              disabled={savingRows[event.id]}
                              className="px-4 py-3 rounded-xl bg-[#4c2f8e] text-white hover:bg-[#3d2572] transition disabled:opacity-50 text-sm font-medium"
                            >
                              {savingRows[event.id] ? 'Enregistrement...' : 'Enregistrer'}
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          ))
        )}
      </section>
    </>
  );
};

export default Planning;